import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
// import { useNavigate } from 'react-router-dom';
import {
  Avatar,
  Card,
  Grid,
  Box,
  CardContent,
  Typography,
  Menu,
  MenuItem,
  IconButton,
  makeStyles
} from '@material-ui/core';
import { MoreVert as MoreVertIcon } from '@material-ui/icons';
import ProductService from '../../../services/ProductService';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  avatar: {
    width: 'auto',
    height: 'auto'
  },
}));

const ProductCard = ({
  className, onSuccess, product, ...rest
}) => {
  const classes = useStyles();
  const [menuIsOpen, setMenuIsOpen] = useState(null);

  const toggleMenu = (e) => setMenuIsOpen(!menuIsOpen ? e.currentTarget : null);

  const approveImage = async () => {
    await ProductService.update(product?.id, {
      ...product,
      is_image_uploaded: false
    });
    onSuccess();
  };

  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
    >
      <CardContent>
        <Grid container spacing={1}>
          <Grid container item xs={3} direction="column" justify="center" alignItems="center">
            <Avatar
              className={classes.avatar}
              alt="product-images"
              src={product?.primary_image}
              variant="square"
            />
          </Grid>
          <Grid container item xs={9} alignItems="flex-start">
            <Grid container item xs={10} alignItems="flex-start">
              <Box mt={1}>
                <Typography
                  align="left"
                  color="textPrimary"
                  gutterBottom
                  variant="h3"
                >
                  {product?.name}
                </Typography>
                <Typography
                  align="left"
                  color="textPrimary"
                  gutterBottom
                  variant="h4"
                >
                  {product?.brand_category?.brand?.name}
                </Typography>
                <Typography
                  align="left"
                  color="textPrimary"
                  gutterBottom
                  variant="caption"
                >
                  {`${product?.brand_category?.brand?.partners[0]?.first_name} ${product?.brand_category?.brand?.partners[0]?.last_name}`}
                </Typography>
              </Box>
            </Grid>
            <Grid container item xs={2} alignItems="flex-start">
              <IconButton onClick={toggleMenu}>
                <MoreVertIcon />
              </IconButton>
              <Menu
                anchorEl={menuIsOpen}
                open={Boolean(menuIsOpen)}
                onClose={toggleMenu}
              >
                <MenuItem onClick={approveImage}>Aprobar imagen</MenuItem>
              </Menu>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

ProductCard.propTypes = {
  className: PropTypes.string,
  product: PropTypes.object.isRequired,
  onSuccess: PropTypes.func,
};

ProductCard.propTypes = {
  className: () => {},
};

export default ProductCard;
